import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, Sparkles } from "lucide-react";
import ProductCard from "./ProductCard";
import { SHOP } from "@/constants/testIds";

export default function DealsCarousel({ products = [], onOpenDetails }) {
  const scrollerRef = useRef(null);
  if (!products.length) return null;

  const scrollBy = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section data-testid={SHOP.dealsSection} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 sm:mt-16">
      <div className="flex items-end justify-between mb-5 sm:mb-7 gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 text-[10px] sm:text-xs uppercase tracking-[0.22em] text-[#FF5722] font-bold">
            <Sparkles size={12} strokeWidth={3} />
            Deals of the Week
          </div>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-black text-gray-900 mt-1 tracking-tight">
            Lowest ever prices, only for 7 days
          </h2>
        </div>
        <div className="hidden sm:flex items-center gap-2">
          <button
            aria-label="Scroll left"
            onClick={() => scrollBy(-1)}
            className="w-10 h-10 rounded-full bg-white border border-gray-200 hover:border-gray-400 grid place-items-center transition-colors"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            aria-label="Scroll right"
            onClick={() => scrollBy(1)}
            className="w-10 h-10 rounded-full bg-white border border-gray-200 hover:border-gray-400 grid place-items-center transition-colors"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>

      <div
        ref={scrollerRef}
        className="flex gap-4 sm:gap-5 overflow-x-auto no-scrollbar snap-x snap-mandatory -mx-4 sm:mx-0 px-4 sm:px-0 pb-2"
      >
        {products.map((p) => (
          <div key={p.id} className="snap-start shrink-0 w-[60%] sm:w-[40%] md:w-[30%] lg:w-[22%]">
            <ProductCard product={p} onOpenDetails={onOpenDetails} />
          </div>
        ))}
      </div>
    </section>
  );
}
